var moduleSingleSaleItem = function() {
  var $ = jQuery;
  var _this;

  var module = {
    init: function() {
      _this = this;
      this.modifyDOM();
      this.addEvents();
    },

    values: {
      object: $('.post__title h1').text(),
      mailto: $('[name="mailto"]').val(),
      name: '',
      phone: '',
      workshop: '',
      mail: ''
    },

    modifyDOM: function() {
    },

    addEvents: function() {
      $('body').on('submit', '.js-interested-form', _this.eventHandlers.submitForm).
                on('change', '[name=name]',         _this.eventHandlers.nameChanged).
                on('change', '[name=phone]',        _this.eventHandlers.phoneChanged).
                on('change', '[name=workshop]',     _this.eventHandlers.workshopChanged).
                on('change', '[name=mail]',         _this.eventHandlers.mailChanged).
                on('change keydown', '[name=name], [name=phone]', _this.eventHandlers.requiredFieldChanged);
    },

    eventHandlers: {
      nameChanged: function(e) {
        _this.values.name = this.value;
      },

      phoneChanged: function(e) {
        _this.values.phone = this.value;
      },

      workshopChanged: function(e) {
        _this.values.workshop = this.value;
      },

      mailChanged: function(e) {
        _this.values.mail = this.value;
      },

      requiredFieldChanged: function() {
        var $form = $('.js-interested-form');

        if (_this.values.name && _this.values.phone) {
          $form.find('[type=submit]').prop('disabled', false);
          $('.validation-error--form').removeClass('active');
        } else {
          $form.find('[type=submit]').prop('disabled', true);
          $('.validation-error--form').addClass('active');
        }
      },

      submitForm: function(e) {
        var $form = $('.js-interested-form');
        var $thanks = $('.js-interested-thanks');

        $form.find('[type=submit]').addClass('btn--spinner--spinning');

        $.post('/wp/wp-admin/admin-ajax.php', {
          action: 'post_interested',
          values: _this.values
        }).success(function() {
          $form.addClass('hide');
          $thanks.removeClass('hide');
        }).fail(function() {
          $form.find('.submit-fail').removeClass('hide');
          $form.find('[type=submit]').removeClass('btn--spinner--spinning');
        });

        return false;
      }
    },

    helpers: {
    }
  };

  module.init();
};
